/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import cx from 'classnames';
import { useTheme } from '../utils/index.js';
/**
 * A standalone label to be used with input components (using `htmlFor`).
 * Can be rendered as any element, e.g. span, using the `as` prop.
 * @example
 * <Label htmlFor='name-input'>Name</Label>
 * <Input id='name-input' />
 */
export const Label = (props) => {
    const { as: Element = 'label', displayStyle = 'block', required, className, children, ...rest } = props;
    useTheme();
    return (React.createElement(Element, { className: cx('iui-input-label', {
            'iui-inline': displayStyle === 'inline',
            'iui-required': required,
        }, className), ...rest }, children));
};
export default Label;
